import request from '@/utils/request'

export const getData = params =>
  request.post('/workflow-api/credit-allocation/overview', params)

export const screeningParentCompany = name =>
  request.get(
    `/customer-api/company-relation-group-limits?companyCodeOrName=${name}`,
  )

export const getBufferValue = params =>
  request.post('/workflow-api/credit-allocation/assigned-from/amount', params)

export const submitForm = params =>
  request.post('/workflow-api/credit-allocation/allocate', params, {
    timeout: 300000,
  })
